// extracted by mini-css-extract-plugin
export var addButton = "recipe-list-module--add-button--34872";
export var grid = "recipe-list-module--grid--15e23";
export var header = "recipe-list-module--header--1d8a9";
export var hero = "recipe-list-module--hero--384c4";
export var list = "recipe-list-module--list--3f43e";